import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { User, UserProps } from './user/user';

interface GetUserDetails {
  name: string;
  value: string;
}

export interface UserDetailsProps {
  data?: UserProps;
  status: LoadingState;
}

export const UserDetails = types
  .model({
    data: types.optional(User, {}),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: UserDetailsProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
    setUserDetails(props: Partial<UserProps>): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        data: { ...self.data, ...props },
      });
    },
  }))
  .actions((self) => ({
    async setUserDetailsStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.profile.userDetails,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setUserDetailsStore();
    },
    async update(): Promise<void> {
      await self.setUserDetailsStore();
    },
  }))
  .views((self) => ({
    getUserDetailsArray(): GetUserDetails[] {
      const { data } = self;
      const snap = getSnapshot(data);
      return Object.entries(snap).map(([name, value]) => ({
        name,
        value,
      }));
    },
  }));

export const userDetails = UserDetails.create();
export type UserDetailsSnapshot = SnapshotIn<typeof UserDetails>;
export type UserDetailsInstance = Instance<typeof UserDetails>;
export default userDetails;
